import { visit, SKIP } from 'unist-util-visit'
import type { Plugin } from 'unified'
import { customElements } from '@/elements'

/**
 * Plugin to unwrap code blocks from redundant pre tags.
 *
 * When we create markdown code blocks we replace the `code` tag with a `scalar-code-block` tag.
 *
 * We will replace the entire node later and we need to remove the redundant pre tag
 */
export function unwrapPreTags(): Plugin {
  return () => (tree: any) => {
    visit(tree, 'element', (node, index, parent) => {
      if (
        node.tagName === 'pre' &&
        Array.isArray(node.children) &&
        node.children.length === 1
      ) {
        const child = node.children[0]

        // Check if the child is a div with the specific class
        if (
          child.type === 'element' &&
          child.tagName === customElements['scalar-code'].tagName
        ) {
          // Replace the pre tag with its child
          if (parent && typeof index === 'number') {
            parent.children[index] = child
            return SKIP
          }
        }
      }
    })
  }
}
